/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconComponent } from '@app/app/shared/styleguide/components/icon/icon.component';
import { LucideX } from '@lucide/angular';
import { TranslocoModule } from '@ngneat/transloco';

/**
 * Chrome for a V3 dialog hosted in a `MatDialog` opened with `panelClass: 'ptl-v3-dialog'`:
 * sticky header with the title, an optional description, the close affordance, and a footer for the
 * actions. Body goes in the default slot, actions in `[dialogFooter]`.
 */
@Component({
  selector: 'ptl-v3-dialog-shell',
  templateUrl: './ptl-v3-dialog-shell.component.html',
  styleUrls: ['./ptl-v3-dialog-shell.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslocoModule],
})
export class PtlV3DialogShellComponent {
  title = input.required<string>();
  description = input<string>('');
  /** Set while a request is in flight, so the dialog cannot be dismissed with the work half done. */
  closeDisabled = input(false);

  closed = output<void>();

  protected readonly LucideX = LucideX;
}
